/* eslint-disable max-params */
import type React from 'react';
import { useEffect } from 'react';
import { ITEM_TYPES } from '../constants/index.js';
import type { DSLeftNavigationT } from '../react-desc-prop-types.js';

const { LEFT_NAV_ITEM_SEPARATOR, LEFT_NAV_ITEM_SECTION } = ITEM_TYPES;

const isSelectableOutOfTheBox = (elem: DSLeftNavigationT.GenericItemItemProps) =>
  typeof elem.type === 'string' && elem.type !== LEFT_NAV_ITEM_SEPARATOR && elem.type !== LEFT_NAV_ITEM_SECTION;
const isSelectableCustom = (elem: DSLeftNavigationT.GenericItemItemProps) => elem.itemOpts.selectable;

const isItemInsideTheTree = (item: DSLeftNavigationT.GenericItemItemProps, itemID: string | null): boolean =>
  item.dsId === itemID || !!item?.itemOpts?.items?.some((it) => isItemInsideTheTree(it, itemID));

export const useSelectFirstBodyItem = (
  items: DSLeftNavigationT.GenericItemItemProps[],
  openedItem: string | null,
  selectedItem: string | null,
  setSelectedItem: React.Dispatch<React.SetStateAction<string | null>>,
  disableDefaultSelection: boolean | undefined,
): void => {
  useEffect(() => {
    if (!disableDefaultSelection && items && items.length && openedItem) {
      const index = items.findIndex((elem) => isSelectableOutOfTheBox(elem) || isSelectableCustom(elem));
      const isItemInside = items.some((it) => isItemInsideTheTree(it, selectedItem));
      if (isItemInside) setSelectedItem(selectedItem);
      else if (index !== -1) setSelectedItem(items[index].dsId ?? '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openedItem, setSelectedItem, disableDefaultSelection]);
};
